(function () {
  const productsListWrapper = document.querySelector('.complementary-products__list');
  const productsZoomImagesModal = document.querySelector('.complementary-products-zoom-images');
  const closeModalBtn = productsZoomImagesModal?.querySelector('.complementary-products-zoom-images__close-btn');

  if (!productsListWrapper || !productsZoomImagesModal || !closeModalBtn) return;

  productsListWrapper.addEventListener('click', (e) => {
    if (e.target.classList.contains('product-complementary__image')) {
      const activeImage = productsZoomImagesModal.querySelector('.complementary-products-zoom-images__image-wrap.active');
      const targetImage = productsZoomImagesModal.querySelector(`[data-id="${e.target.dataset.id}"]`);

      if (!targetImage) return;

      if (activeImage) {
        activeImage.classList.remove('active')
      }

      targetImage.classList.add('active');
      productsZoomImagesModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
  });

  productsZoomImagesModal.addEventListener('click', (e) => {
    if (e.target.classList.contains('complementary-products-zoom-images__image')) return;

    productsZoomImagesModal.classList.remove('active');
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
  });
})();
